import { useList, useGetIdentity } from "@refinedev/core";

export const useBillingInfo = () => {
  const { data: identity } = useGetIdentity<{ id?: string; user_id?: string }>();
  
  const userId = identity?.id || identity?.user_id;
  
  const { data, isLoading, refetch } = useList({
    resource: "user_billing_info",
    filters: [
      {
        field: "user_id",
        operator: "eq",
        value: userId,
      },
    ],
    meta: {
      fields: ["id", "user_id", "email", "phone_number", "document_id", "created_at", "updated_at"]
    },
    queryOptions: {
      enabled: !!userId,
    },
  });

  const hasBillingInfo = data?.data && data.data.length > 0;
  const billingInfo = data?.data?.[0];

  return {
    hasBillingInfo,
    billingInfo,
    isLoading,
    refetch,
  };
};